/**
 * ReferralBlock — the read-side referral source line (org/individual
 * Directory link or free text), extracted from WorkItemDrawer (UX-11
 * PR-2). The editable tagged-union picker lives in the intake-details
 * form (ReferralSourceField); this is display-only.
 */

import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import type { WorkItemDetail } from '@/lib/api';

export interface ReferralBlockProps {
  detail: WorkItemDetail;
  tenantSlug: string;
}

export function ReferralBlock({ detail, tenantSlug }: ReferralBlockProps): ReactNode {
  const referralName = detail.referral_org_resolved_name ?? detail.referral_individual_name ?? null;
  const referralHref = detail.referral_org_resolved_id
    ? `/t/${tenantSlug}/organizations/${detail.referral_org_resolved_id}`
    : detail.referral_individual_id
      ? `/t/${tenantSlug}/individuals/${detail.referral_individual_id}`
      : null;

  return (
    <>
      {referralHref && referralName ? (
        <Link to={referralHref} className="text-sage-800 font-semibold border-b border-warm-400 no-underline" data-testid="referral-link">{referralName}</Link>
      ) : referralName ? (
        referralName
      ) : null}
      {detail.referral_text && <span>{referralName ? `, ${detail.referral_text}` : detail.referral_text}</span>}
    </>
  );
}
